export default "__VITE_ASSET__BiSA82y0__"